import axios from "axios";
import { getAuthToken } from "@dynamic-labs/sdk-react-core";

const rexlaAxios = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL, //YOUR_API_URL HERE
  /* withCredentials: true, */
  headers: {
    "Content-Type": "application/json",
  },
});

// Add an interceptor to include the Magic ID token in requests
rexlaAxios.interceptors.request.use(
  async (config) => {
    const dynamicJwtToken = getAuthToken();
    if (dynamicJwtToken) {
      config.headers.Authorization = `Bearer ${dynamicJwtToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default rexlaAxios;
